import $ from "jquery";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

$(function () {

    //ScrollTrigger-------------------------------------------------
    gsap.registerPlugin(ScrollTrigger);

    // //backtotop
    // $('.backtotop_link').click(function(e) {
    //     e.preventDefault();
    //     gsap.to('html, body', { duration: 1, scrollTop: 0, ease: 'quart.out' });
    // });

    // gsap.to('.backtotop', {
    //     scrollTrigger: {
    //         trigger: '.about_sec',
    //         start: 'top 20%', // trigger物件的頂端(top),碰觸到視窗的中段(center)時啟動
    //         endTrigger: '.footer',
    //         end: 'top 100%',
    //         toggleActions: "restart reverse restart reverse", // "onEnter onLeave onEnterBack onLeaveBack"
    //     },
    //     duration: .4,
    //     opacity: 1,
    //     display: 'block',
    //     ease: 'power2.out',
    // })


    //aside_navigation
    let _this;
    let _end;
    let _anchor;
    let _offsetTop;
    $('.aside_nav_link').click(function (e) {
        e.preventDefault();
        _this = $(this);
        _anchor = _this.attr('href');
        _offsetTop = $(_anchor).offset().top;
        gsap.to('html,body', { duration: 1, scrollTop: _offsetTop, ease: 'quart.out' });
    });

    gsap.to('.aside_navigation', {
        duration: .8,
        opacity: 1,
        y: 0,
        display: 'block',
        scrollTrigger: {
            trigger: '.about_sec',
            start: 'top center', // trigger物件的頂端(top),碰觸到視窗的中段(center)時啟動
            endTrigger: '.footer',
            end: 'top 100%',
            toggleActions: "restart reverse restart reverse", // "onEnter onLeave onEnterBack onLeaveBack"
        },
        ease: 'quart.out',
    });
    _end = $('.about_sec').outerHeight(true) / 1.9;
    gsap.timeline({
        scrollTrigger: {
            trigger: '.about_sec',
            start: 'top center',
            end: "+=" + _end,
            toggleClass: { targets: '.nav_1', className: 'active' }
        }
    });
    _end = $('.artist_sec').outerHeight(true) / 1.1;
    gsap.timeline({
        scrollTrigger: {
            trigger: '.artist_sec',
            start: 'top center',
            end: "+=" + _end,
            toggleClass: { targets: '.nav_2', className: 'active' }
        }
    });
    _end = $('.curator_sec').outerHeight(true);
    gsap.timeline({
        scrollTrigger: {
            trigger: '.curator_sec',
            start: 'top center',
            end: "+=" + _end,
            toggleClass: { targets: '.nav_3', className: 'active' }
        }
    });
    _end = $('.floorplan_sec').outerHeight(true);
    gsap.timeline({
        scrollTrigger: {
            trigger: '.floorplan_sec',
            start: 'top center',
            end: "+=" + _end,
            toggleClass: { targets: '.nav_4', className: 'active' }
        }
    });
    _end = $('.tfam_sec').outerHeight(true);
    gsap.timeline({
        scrollTrigger: {
            trigger: '.tfam_sec',
            start: 'top center',
            end: "+=" + _end,
            toggleClass: { targets: '.nav_5', className: 'active' }
        }
    });
    _end = $('.location_sec').outerHeight(true);
    gsap.timeline({
        scrollTrigger: {
            trigger: '.location_sec',
            start: 'top center',
            end: "+=" + _end,
            toggleClass: { targets: '.nav_6', className: 'active' }
        }
    });

    _end = $(window).height() * 5;
    gsap.to('.bg_light_1', {
        duration: 1,
        opacity: 0,
        scrollTrigger: {
            trigger: '.artist_sec',
            start: 'top center',
            end: "+=" + _end,
            toggleActions: "restart none none reverse",
            scrub: 1,
        },
    })

    _end = $(window).height() * 2.5;
    gsap.timeline({
        scrollTrigger: {
            trigger: '.artist_sec',
            start: 'top center',
            end: "+=" + _end,
            toggleActions: "restart none none reverse",
            scrub: 1,
        },
    })
        .to('.bg_light_2', { duration: 1, opacity: 1 })
        .to('.bg_light_2', { duration: 1, opacity: 0 })

    _end = $(window).height() * 1;
    gsap.timeline({
        scrollTrigger: {
            trigger: '.floorplan_sec',
            start: 'top center',
            end: "+=" + _end,
            toggleActions: "restart none none reverse",
            scrub: 1,
        },
    })
        .to('.bg_light_3', { duration: 1, opacity: 1 })
        .to('.bg_light_3', { duration: 1, opacity: 0 })
});